import { Grid, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import {
  AccountTreeOutlined,
  FullscreenOutlined,
  InfoOutlined,
} from "@mui/icons-material";
import DiagramaEquipamentos from "../diagramaEquipamentos";
import useStyles from "./styles";

// Seção "Diagrama de Equipamentos" do formulário de circuito: fronteira que a
// etapa de hierarquia (fora deste plano) vai transformar na aba "Diagrama" de
// fato — hoje ainda renderizada empilhada na mesma posição visual de antes,
// última seção do circuito. Extraída de circuito/index.js (Task 6 da
// decomposição), mesmo JSX/comportamento. O estado do diagrama (useDiagramaState/
// useNodeAnexos) mora em circuito/index.js e chega aqui via props (Task 4 da
// hierarquia de circuitos) — sem ref imperativo, o save não depende mais dele.
export default function DiagramaTab({
  diagrama,
  nodeAnexos,
  diagramInstanceKey,
  editMode,
  isActive,
  isExpanded,
  onToggleExpanded,
  circuitoPersisted,
  circuitoId,
  hostOptions,
  setSnackbar,
  onSalvarCircuito,
  salvandoCircuito,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <>
      <Grid item xs={12} sx={styles.gritItemTitle}>
        <AccountTreeOutlined color="primary" />
        <Typography variant="mySubtitle2">Diagrama de Equipamentos</Typography>
        <Tooltip
          title="Monte o diagrama de equipamentos do circuito clicando nos tipos da paleta e conectando os nós. As conexões podem receber um label (ex: 1 Gbps) e um estilo de linha (contínua, tracejada ou pontilhada). Os dados ficam salvos localmente no navegador."
          arrow
        >
          <InfoOutlined
            sx={{
              color: theme.palette.tertiary.light,
              fontSize: 18,
              cursor: "pointer",
            }}
          />
        </Tooltip>
        {!isExpanded && (
          <Tooltip title="Ampliar diagrama" arrow>
            <IconButton
              size="small"
              sx={styles.diagramFullscreenButton}
              onClick={onToggleExpanded}
              aria-label="Ampliar diagrama"
            >
              <FullscreenOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
      <Grid container spacing={1} sx={styles.contentIdentation}>
        <Grid item xs={12}>
          <DiagramaEquipamentos
            diagrama={diagrama}
            nodeAnexos={nodeAnexos}
            diagramInstanceKey={diagramInstanceKey}
            editMode={editMode}
            isActive={isActive}
            isExpanded={isExpanded}
            onToggleExpanded={onToggleExpanded}
            setSnackbar={setSnackbar}
            circuitoPersisted={circuitoPersisted}
            circuitoId={circuitoId}
            hostOptions={hostOptions}
            onSalvarCircuito={onSalvarCircuito}
            salvandoCircuito={salvandoCircuito}
          />
        </Grid>
      </Grid>
    </>
  );
}
